module.exports = __webpack_public_path__ + "img/Report-active.b0840221.svg";